"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTraceData = getTraceData;

var _index = require("../asyncContext/index.js");

var _carrier = require("../carrier.js");

var _currentScopes = require("../currentScopes.js");

var _exports = require("../exports.js");

require("../tracing/errors.js");

require("../utils-hoist/debug-build.js");

var _logger = require("../utils-hoist/logger.js");

require("../debug-build.js");

require("../utils-hoist/time.js");

var _spanUtils = require("./spanUtils.js");

var _tracing = require("../utils-hoist/tracing.js");

var _dynamicSamplingContext = require("../tracing/dynamicSamplingContext.js");

var _baggage = require("../utils-hoist/baggage.js");

/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values to strings. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */
function getTraceData(options = {}) {
  const client = (0, _currentScopes.getClient)();

  if (!(0, _exports.isEnabled)() || !client) {
    return {};
  }

  const carrier = (0, _carrier.getMainCarrier)();
  const acs = (0, _index.getAsyncContextStrategy)(carrier);

  if (acs.getTraceData) {
    return acs.getTraceData(options);
  }

  const scope = (0, _currentScopes.getCurrentScope)();
  const span = options.span || (0, _spanUtils.getActiveSpan)();
  const sentryTrace = span ? (0, _spanUtils.spanToTraceHeader)(span) : scopeToTraceHeader(scope);
  const dsc = span ? (0, _dynamicSamplingContext.getDynamicSamplingContextFromSpan)(span) : (0, _dynamicSamplingContext.getDynamicSamplingContextFromScope)(client, scope);
  const baggage = (0, _baggage.dynamicSamplingContextToSentryBaggageHeader)(dsc);

  const isValidSentryTraceHeader = _tracing.TRACEPARENT_REGEXP.test(sentryTrace);

  if (!isValidSentryTraceHeader) {
    _logger.logger.warn('Invalid sentry-trace data. Cannot generate trace data');

    return {};
  }

  return {
    'sentry-trace': sentryTrace,
    baggage
  };
}
/**
 * Get a sentry-trace header value for the given scope.
 */


function scopeToTraceHeader(scope) {
  // TODO(v9): Use generateSpanId() instead of spanId
  // eslint-disable-next-line deprecation/deprecation
  const _scope$getPropagation = scope.getPropagationContext(),
        traceId = _scope$getPropagation.traceId,
        sampled = _scope$getPropagation.sampled,
        spanId = _scope$getPropagation.spanId;

  return (0, _tracing.generateSentryTraceHeader)(traceId, spanId, sampled);
}